const setLocalStorage = (key: string, value: string) =>
  localStorage.setItem(key, value);

export default setLocalStorage;
